import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TrackedActionsService {
  private userTrackedActionHappened$ = new Subject<void>();

  public emitUserTrackedAction(): void {
    this.userTrackedActionHappened$.next();
  }

  public onUserTrackedActionEmit(): Observable<void> {
    return this.userTrackedActionHappened$.asObservable();
  }
}
